import { d as defineCustomElement } from '../chunks/vidstack-Uw94Yvrg.js';
import { a as MediaPlayerElement, M as MediaProviderElement } from '../chunks/vidstack-BHgVWl1l.js';
import '../chunks/vidstack-DLpJQ4a5.js';
import '../chunks/vidstack-D73YzvPy.js';
import '../chunks/vidstack-VrKElWm_.js';
import '../chunks/vidstack-BYKVJb7W.js';
import '../chunks/vidstack-DSCDp3Na.js';
import '../chunks/vidstack-69_0Ad1E.js';
import '../chunks/vidstack-ByTY2VS-.js';
import '../chunks/vidstack-Du-_dEIb.js';
import '../chunks/vidstack-BSXZsAhp.js';
import '../chunks/vidstack-BUqeBbTQ.js';
import '../chunks/vidstack-ksPACRiU.js';
import '../chunks/vidstack-CSaHpIQV.js';
import '../chunks/vidstack-Dchp6m-3.js';

defineCustomElement(MediaPlayerElement);
defineCustomElement(MediaProviderElement);
